export type OauthProvider = 'hotmail' | 'google';
export type GitProvider = 'gitlab' | 'github';

export const constants = {
    OAUTH_PROVIDERS: ['hotmail', 'google'],
    GIT_PROVIDERS: ['gitlab', 'github'],
    SHAPES: ['round', 'triangle', 'polygon', 'rectangle', 'trapeze'],
};
